import { AgeType } from "../api/contracts/reservation";

/**
 * A booking made up solely of infants (no adults, teenagers or children) is
 * never bookable: an infant cannot occupy a unit on its own, it only
 * accompanies an older guest. Such a mix is neither searchable, selectable,
 * priced nor displayed. Mirrors the backend `isInfantsOnlyGuestCount` gate.
 *
 * Accepts any guest shape carrying an `ageType`, so both the category-ads and
 * reservation `Guest` types work without conversion.
 */
export const isInfantsOnlyGuestList = (
  guests: readonly { ageType: AgeType }[],
): boolean =>
  guests.length > 0 && guests.every((guest) => guest.ageType === "infant");

/** Count-based variant of {@link isInfantsOnlyGuestList}. */
export const isInfantsOnlyCounts = (counts: {
  adults?: number;
  teenagers?: number;
  children?: number;
  infants?: number;
}): boolean =>
  (counts.infants ?? 0) > 0 &&
  (counts.adults ?? 0) + (counts.teenagers ?? 0) + (counts.children ?? 0) === 0;
